'use client'

import { type TFunction } from 'i18next'
import * as z from 'zod'

export const gebaseRegisterSchema = (t: TFunction<'common', undefined>) =>
  z
    .object({
      firstName: z
        .string()
        .min(3, { message: t('register.validation.firstName.min') })
        .max(20, { message: t('register.validation.firstName.max') }),
      lastName: z
        .string()
        .min(3, { message: t('register.validation.lastName.min') })
        .max(20, { message: t('register.validation.lastName.max') }),
      email: z.string().email({ message: t('register.validation.email.invalid') }),
      password: z.string().min(8, { message: t('register.validation.password.min') }),
      confirmPassword: z.string().min(1, { message: t('register.validation.confirmPassword.required') }),
      captchaToken: z.string().min(1, { message: t('register.validation.captcha.required') }),
    })
    .refine(data => data.password === data.confirmPassword, {
      message: t('register.validation.confirmPassword.match'),
      path: ['confirmPassword'],
    })

export type RegisterFormType = z.infer<ReturnType<typeof gebaseRegisterSchema>>
